/**
 * Shared data for Landing-page sub-components extracted in the refactor.
 * Keep in lock-step with `pages/Province.jsx` PROVINCES.
 */
import { Hammer, Scale, Calculator, Users, FileText, TrendingUp } from "lucide-react";

export const LANDING_PROVINCES = [
  ["bc",  "British Columbia"],         ["ab",  "Alberta"],
  ["sk",  "Saskatchewan"],             ["mb",  "Manitoba"],
  ["on",  "Ontario"],                  ["qc",  "Quebec"],
  ["nb",  "New Brunswick"],            ["ns",  "Nova Scotia"],
  ["pei", "Prince Edward Island"],     ["nl",  "Newfoundland & Labrador"],
  ["yt",  "Yukon"],                    ["nt",  "Northwest Territories"],
  ["nu",  "Nunavut"],
];

export const SOFTWARE_SLUG = {
  bc: "british-columbia", ab: "alberta", sk: "saskatchewan", mb: "manitoba",
  on: "ontario", qc: "quebec", nb: "new-brunswick", ns: "nova-scotia",
  pei: "prince-edward-island", nl: "newfoundland-and-labrador",
  yt: "yukon", nt: "northwest-territories", nu: "nunavut",
};

export const DIY_RESOURCES = [
  { icon: Hammer,     title: "DIY repairs that pay back",         body: "5 plumbing fixes, drywall patching, painting in 6 hours, annual furnace/AC service.",       href: "/blog", tag: "Repairs" },
  { icon: Scale,      title: "Province-by-province RTA cheatsheet", body: "Notice periods, deposits, rent-increase caps. The numbers most landlords forget.",          href: "/laws/on", tag: "Compliance" },
  { icon: Calculator, title: "T776 walkthrough for landlords",     body: "Line-by-line: gross rent, vacancy, expenses, CCA — and the recapture trap.",                href: "/blog", tag: "Tax" },
  { icon: Users,      title: "Screening tenants (PIPEDA-safe)",     body: "Equifax pulls, income docs, references. What you can ask and what you can't.",             href: "/blog", tag: "Screening" },
  { icon: FileText,   title: "Lease clauses tenants read",          body: "Province-specific clauses, the Schedule A trick, e-signatures that hold up in tribunal.",  href: "/blog", tag: "Leases" },
  { icon: TrendingUp, title: "BRRRR — Canadian edition",            body: "Buy · Rehab · Rent · Refi · Repeat — modeled against Canadian mortgage rules.",            href: "/blog", tag: "Growth" },
];
